import React from "react";
import { footerInfo, SHOP_BASE } from "../mock";

const FooterLogo = () => (
  <img
    src="/maxima-logo.png"
    alt="Maxima Racing Oils"
    className="h-14 md:h-16 w-auto"
  />
);

const Footer = () => {
  const { links, marketedBy } = footerInfo;
  return (
    <footer className="bg-[#0a0a0a] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
          <FooterLogo />

          <div>
            <h4 className="heading-font text-xl mb-4 tracking-wide">INFO</h4>
            <ul className="space-y-2">
              {links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 hover:text-[#ED1C24] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:text-right">
            <h4 className="heading-font text-lg mb-3 tracking-wide">MARKETED BY</h4>
            <p className="heading-font text-sm text-gray-200">{marketedBy.company}</p>
            {marketedBy.address.map((line) => (
              <p key={line} className="heading-font text-sm text-gray-400">{line}</p>
            ))}
            <p className="heading-font text-sm text-gray-200 mt-2">
              CONNECT : {marketedBy.phone}
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <a
            href={`${SHOP_BASE}/policies/terms-of-service`}
            target="_blank"
            rel="noreferrer"
            className="text-gray-400 hover:text-white text-xs heading-font tracking-wide"
          >
            Terms and Policies
          </a>
          <p className="text-gray-500 text-xs heading-font tracking-wide">
            © 2026 Maxima Racing Oils - India, Powered by Shopify
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
